import styled, { css } from 'styled-components';

import { media } from '../../../styles/media';

export const Container = styled.div`
  ${media.from_tablet`
    padding: 8xp;
  `}
`;
